import React from 'react';
import { Home,DeveloperBoard } from '@mui/icons-material';
import {Snackbar, Alert, AlertTitle} from '@mui/material';
import ActivityBuilderContainer from '../others-component/ActivityBuilderContainer';
import Footer from '../utils/footer';
import Header from '../utils/header';
import { Page } from '../utils/datautils';

export default function ActivityBuilder() {
    const[error,setError] = React.useState();
    const[response,setResponse] = React.useState();
    return(
      <>
        <Header path1={Page.HOME} path2={Page.TEAM} icon1={<Home/>} icon2={<DeveloperBoard/>}
          desc1='Home' desc2='Our Team'/>
        <div style={{height:'60px'}}/>
        <ActivityBuilderContainer setError={setError} setResponse={setResponse}/>
        <Footer/>
        <Snackbar open={Boolean(error)} anchorOrigin={{vertical:'top', horizontal:'center'}} autoHideDuration={3000} onClose={a => setError(null)}>
          <Alert severity='error' onClose={a => setError(null)}>
            <AlertTitle>Error</AlertTitle>
            {error}
          </Alert>
        </Snackbar>
        <Snackbar open={Boolean(response)} anchorOrigin={{vertical:'top', horizontal:'center'}} autoHideDuration={3000} onClose={a => setResponse(null)}>
          <Alert severity='success' onClose={a => setResponse(null)}>
            {response}
          </Alert>
        </Snackbar>
     </>
    )
}
